if (!customElements.get("nss-video-card")) {
    customElements.define(
        "nss-video-card",
        class NSSVideoCard extends HTMLElement {
            constructor() {
                super();

                this.selectors = {
                    toggle: ".js-nss-video-card-toggle",
                    video: "video"
                };

                this.video = this.querySelector(this.selectors.video);
                this.toggle = this.querySelector(this.selectors.toggle);

                if (!this.video || !this.toggle) return;

                this.init();
            }

            play() {
                this.pauseOtherCards();
                this.video.play();
                this.classList.add("is-video-playing");
            }

            pause() {
                this.video.pause();
                this.classList.remove("is-video-playing");
            }

            pauseOtherCards() {
                this.closest('nss-carousel')?.querySelectorAll("nss-video-card.is-video-playing").forEach((card) => {
                        if (card !== this) {
                            card.pause();
                        }
                    });
            }

            toggleVideo() {
                if (this.video.paused) {
                    this.play();
                } else {
                    this.pause();
                }
            }

            init() {
                this.toggle.addEventListener("click", (e) => {
                    e.preventDefault();
                    this.toggleVideo();
                });

                // Sync state with native controls
                this.video.addEventListener("play", () => {
                    this.pauseOtherCards();
                    this.classList.add("is-video-playing");
                });

                this.video.addEventListener("pause", () => {
                    this.classList.remove("is-video-playing");
                });
            }
        }
    );
}
